// extracted by mini-css-extract-plugin
module.exports = {"download-apps":"style_download-apps__1Vdtm"};